import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function LegalFAQ() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography
            variant="body"
            sx={{ fontSize: "16pt", width: "100%", flexShrink: 0 }}
          >
            How long do I have to make a claim against the insurance after an
            accident?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body" sx={{ fontSize: "16pt" }}>
            Time is short. In Texas, you have 2 years to sue the person
            responsible for your injuries. If you need to file suit immediately,
            do not hesitate to contact me. If you are in a car accident, the
            insurance will stall as long as possible in order to eliminate your
            option to sue their insured. If you were involved in an accident in
            the last 20 months, you should contact an attorney as soon as
            possible to determine what your best strategy, given the limited
            time available. Making a successful claim takes collaboration and
            evidence.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography
            variant="body"
            sx={{ fontSize: "16pt", width: "100%", flexShrink: 0 }}
          >
            How long does it take to receive a settlement from the responsible
            insurance?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body" sx={{ fontSize: "16pt" }}>
            It depends. Most clients will not have enough time to make a
            successful claim given less than four months. In my experience, even
            in open and shut cases, the average time to file a claim and receive
            what you are owed is four to six months. If you have less time than
            that, contact an attorney immediately to preserve your right to
            financial recovery.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography
            variant="body"
            sx={{ fontSize: "16pt", width: "100%", flexShrink: 0 }}
          >
            After my accident, the hospital filed a lien on me to recover the
            medical costs, what does that mean?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body" sx={{ fontSize: "16pt" }}>
            A lien is a financial interest upon any settlement that you may
            receive from a liable insurance company. If the hospital hasn’t
            filed a lien yet, you may be able to negotiate your bill down.
            However most hospitals file a lien as soon as they realize you were
            involved in a car accident. Worse, some hospitals still do this even
            if you had medical insurance at the time. This does not apply to
            your own auto insurance if you must file an Uninsured Motorist claim
            or Under-Insured motorist claim. To find the law in Texas, go here:
            <span>
              <a href="https://statutes.capitol.texas.gov/Docs/PR/htm/PR.55.htm">
                https://statutes.capitol.texas.gov/Docs/PR/htm/PR.55.htm
              </a>
            </span>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={expanded === "panel4"}
        onChange={handleChange("panel4")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
        >
          <Typography
            variant="body"
            sx={{ fontSize: "16pt", width: "100%", flexShrink: 0 }}
          >
            Will my insurance rates go up if I file a Personal Injury
            Protection, Uninsured Motorist, or Underinsured Motorist Claim?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body" sx={{ fontSize: "16pt" }}>
            The short answer is probably not. Your insurance will do a risk
            assessment, however if you were not at fault for the auto accident,
            then your rates should not go up. Even if your rates do go up, the
            annual increase is typically much less than the amount you can
            recover by filing these claims. In the calculus, it will depend on
            whether your medical bills are high enough to make filing a claim
            advantageous.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
